import { render, staticRenderFns } from "./KsLink.vue?vue&type=template&id=ffd5af3c"
import script from "./KsLink.vue?vue&type=script&lang=js"
export * from "./KsLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports